import type {Variants} from 'motion/react';

export const PointerTransition: Variants = {
    exit: {
        opacity: 0,
        scale: 0.6,
        transition: {duration: 0.5},
        x: '-50%',
        y: '-50%'
    },
    hidden: {
        opacity: 0,
        scale: 0.1,
        transition: {duration: 0.5},
        x: '-50%',
        y: '-50%'
    },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {duration: 0.5},
        x: '-50%',
        y: '-50%'
    }
};